/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export type AlertKind = 'error' | 'warning' | 'success' | 'info';

export class AlertKinds {
  static readonly ERROR: AlertKind = 'error';
  static readonly WARNING: AlertKind = 'warning';
  static readonly SUCCESS: AlertKind = 'success';
  static readonly INFO: AlertKind = 'info';
}

export interface AlertData {
  message: string;
  kind?: AlertKind;
  timeout?: number;
}

export class Alert implements AlertData {
  readonly message: string;
  readonly kind: AlertKind;
  readonly timeout: number;

  constructor(data: AlertData) {
    this.message = data.message;
    this.kind = data.kind || AlertKinds.INFO;
    this.timeout = data.timeout;
  }

}
